'use strict';

module.exports = function zip(array) {
  var collection = this.items.map(function (item, index) {
    return [item, array[index]];
  });

  return new this.constructor(collection);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/zip.js
// module id = 1231
// module chunks = 2